import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Table, Tag, Select, Pagination } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const DraftOrders = () => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState();
  const [pageDetails, setPageDetails] = useState([]);
  const [reFetch, setRefetch] = useState();

  const columns = [
    {
      title: "Razorpay Order ID",
      dataIndex: "razorPayOrderId",
    },
    {
      title: "Action",
      dataIndex: "pendingAmount",
      render: (text, record) => (
        <Tag
          role="button"
          color="#87d068"
          onClick={() => {
            createOrder(record);
            // setOpenPaymentPopUp(true);
          }}
        >
          Create
        </Tag>
      ),
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await axios.get("/list-draft-orders").catch((error) => {
          Helper.ErrorHanlder(error);
        });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setLoading(false);
        }
      } catch (error) {
        Helper.ErrorHanlder(error);
      }
    })();
  }, [reFetch]);

  const createOrder = async (detail) => {
    try {
      setLoading(true);
      const checkOrder = await axios
        .post("/verify-payment-order", detail)
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });
      if (!checkOrder) {
        setLoading(false);
        return false;
      }

      detail.orderObj.paymentId = checkOrder.data.paymentId;
      detail.orderObj.razorPayOrderId = detail.razorPayOrderId;

      const data = await axios
        .post("/web-orders", detail.orderObj)
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });

      if (data && data.data) {
        setLoading(false);
        setRefetch(Date.now());
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    } finally {
      setLoading(false);
      setRefetch(Date.now());
    }
  };

  return (
    <Container>
      <Row>
        <Col md={12}>
          <div className="shop-pg">
            <Table
              columns={columns}
              dataSource={pageDetails}
              pagination={false}
              loading={loading}
              rowKey="id"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default DraftOrders;
